import { get, writable, derived } from 'svelte/store';
import { idb } from '../db';

const initRecent = () => {
    const { subscribe, set, update } = writable([]);
    const helpers = {
        init: async ( recentUid ) => {
            console.group(`INFO: recent.init`);console.log(recentUid);console.groupEnd();
            set(await idb.get( 'pc_recent', recentUid));
        },
        add: async ( uid, data , options ) => { update( async current => {
            console.group(`INFO: recent.add`);
            // Update current category
            // If entry is already in the list of recent entries => Bring top of list
            console.log(`Current data`); console.log(current);
            let newState;
            if ( current ) {
                if( current.entries.findIndex( state => state.uid == data.uid ) >= 0 ) { current.entries.splice(current.entries.findIndex( state => state.uid == data.uid),1) }
                newState = {uid: uid, entries: [data, ...current.entries].slice(0,3)} ;
            } else {
                newState = {uid: uid, entries: [data]} ;
            }
            
            console.log(`New data`); console.log(newState);
            idb.save( 'pc_recent', [newState]);
            // Options
            if ( options ) {
            // Related store
                if ( options.relatedStore ) {
                    const relatedStore = await idb.get( 'pc_recent', options.relatedStore);
                    console.log(`Related store:`); console.log(relatedStore);
                    let updatedStore;

                    if ( relatedStore ) {
                        if( relatedStore.entries.findIndex( s => s.uid == data.uid ) >= 0 ) { relatedStore.entries.splice(relatedStore.entries.findIndex( s => s.uid == data.uid),1) }
                        updatedStore = {uid: options.relatedStore, entries: [data, ...relatedStore.entries].slice(0,3)} ;
                    } else {
                        updatedStore = {uid: options.relatedStore, entries: [data]} ;
                    }
                    
                    console.log(`updatedStore`);console.log(updatedStore);
                    idb.save( 'pc_recent', [updatedStore]);
                } 
            }
            
            console.groupEnd();
            return newState;
        })}
    }
    return {
        subscribe,
        set,
        update,
        ...helpers
    }
};
export const recentIDB = initRecent();
